// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"227":"f6834a70","230":"2de8a042","247":"be1c8277","457":"ec944140","900":"6d7c6fb7"}[chunkId] + ".chunk.css";
};